module.exports = __webpack_public_path__ + "static/media/ice45.89b34841.webp";